module.exports = __webpack_public_path__ + "img/flag_jp.3919b660.svg";